module.exports = __webpack_public_path__ + "static/img/35.2fc0f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/35.png
// module id = PlUF
// module chunks = 0